import { Route } from 'react-router-dom';

import NotificationsPage from '../NotificationsPage';

const NotificationsContentRouter: React.FC = () => (
  <Route
    path="/projects/:projectid/notifications/"
    component={NotificationsPage}
  />
);

export default NotificationsContentRouter;
